import Head from "next/head"
import { useRouter } from "next/router"
import { useNextRouterViewTransitions } from "use-view-transitions/next"

import "styles.css"
import "@fontsource/roboto-slab/500.css"
import "@fontsource/roboto-slab/600.css"
import "@fontsource/roboto-condensed"
import "@fontsource/roboto-condensed/700.css"
import "@fontsource/roboto"
import "@fontsource/roboto/700.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/400-italic.css"

import PreviewAlert from "components/PreviewAlert"
import Header from "components/Header"
import Footer from "components/Footer"

import useStoryblok from "storyblok/useStoryblok"
import { resolve_relations } from "storyblok/resolveRelations"

function MyApp({ Component, pageProps: { preview, story, globals, ...remainingProps } }) {
  const router = useRouter()
  useNextRouterViewTransitions(router)
  story = useStoryblok({ story, resolve_relations })

  return (
    <>
      <Head>
        <link rel="icon" type="image/png" href="/favicon/favicon-96x96.png" sizes="96x96" />
<link rel="icon" type="image/svg+xml" href="/favicon/favicon.svg" />
<link rel="shortcut icon" href="/favicon/favicon.ico" />
<link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
<meta name="apple-mobile-web-app-title" content="OneQuest Health" />
<link rel="manifest" href="/favicon/site.webmanifest" />
      </Head>
      {preview && <PreviewAlert />}
      <div className="page">
        <Header {...globals} />
        <Component story={story} {...remainingProps} />
        <Footer globals={globals} />
      </div>
    </>
  )
}

export default MyApp
